export default __webpack_public_path__ + "static/Blind-angels-zakia-profile-2bb27e1a7a505f7cf0c607a9403505ca.png";